/**
 * Normaliza el usuario local (.NET) a camelCase estable.
 * Evita que Id/Name/Cedula (PascalCase) dejen la navbar y Mis cursos sin usuario.
 */
export const normalizeLocalUser = (raw) => {
  if (!raw || typeof raw !== 'object') return null;

  const id = raw.id ?? raw.Id ?? null;
  const numericId = id != null && id !== '' ? Number(id) : null;
  const resolvedId =
    numericId != null && !Number.isNaN(numericId) ? numericId : id;

  if (resolvedId == null || resolvedId === '') return null;

  const role = raw.role ?? raw.Role ?? null;
  const label = raw.label ?? raw.Label ?? null;
  const roleId =
    raw.roleId ??
    raw.RoleId ??
    role?.id ??
    role?.Id ??
    null;
  const labelId =
    raw.labelId ??
    raw.LabelId ??
    label?.id ??
    label?.Id ??
    null;

  const labelName = label?.name ?? label?.Name ?? null;
  const roleName = role?.name ?? role?.Name ?? null;

  return {
    ...raw,
    id: resolvedId,
    name: raw.name ?? raw.Name ?? raw.user ?? '',
    cedula: String(raw.cedula ?? raw.Cedula ?? '').trim(),
    email: raw.email ?? raw.Email ?? null,
    login: raw.login ?? raw.Login ?? raw.email ?? raw.Email ?? null,
    roleId: roleId != null ? Number(roleId) || roleId : null,
    labelId: labelId != null ? Number(labelId) || labelId : null,
    role: role
      ? {
          ...role,
          id: role.id ?? role.Id ?? null,
          name: roleName,
        }
      : null,
    label: label
      ? {
          ...label,
          id: label.id ?? label.Id ?? null,
          name: labelName,
          isProfile: Boolean(label.isProfile ?? label.IsProfile),
        }
      : null,
    // En navbar: especialidad/perfil (VP, etc.), no el rol de sistema
    profile:
      raw.profile ??
      raw.Profile ??
      labelName ??
      null,
    isDoctor: Boolean(raw.isDoctor ?? raw.IsDoctor),
  };
};

export const getLocalUserId = (user) => {
  const normalized = normalizeLocalUser(user);
  return normalized?.id ?? null;
};

/** Texto visible bajo el nombre en la navbar: rol + especialidad/perfil (ej. "Estudiante · VP") */
export const getUserProfileLabel = (user) => {
  const normalized = normalizeLocalUser(user) || user;
  if (!normalized || typeof normalized !== 'object') return 'Sin especialidad';

  const roleId = normalized.roleId != null ? Number(normalized.roleId) : null;
  const roleName =
    normalized.role?.name ||
    ({ 1: 'Estudiante', 2: 'Admin', 3: 'Profesor' }[roleId] ?? null);

  const profileName = normalized.profile || normalized.label?.name || null;

  if (roleName && profileName && roleName !== profileName) {
    return `${roleName} · ${profileName}`;
  }

  return roleName || profileName || 'Sin especialidad';
};
